import React, { MouseEvent } from 'react';
import { HeaderUserTypeData } from '../../../../../../components/blackrock/advisor-center/_types/header';
import { Menu } from '../../../../../../components/blackrock/advisor-center/_types/navigation';
import { getKeys } from '../../../../../../_helpers/keyboard';

import './HeaderUserTypeMobile.scss';

export type HeaderUserTypeMobileProps = {
	isExpanded: boolean;
	isOpen: boolean;
	isUserTypeVisible: boolean;
	menu: Menu[];
	selectedMenuIndex: number;
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	selectMenuIndex: (number) => void;
	userType: HeaderUserTypeData;
	setUserTypeVisible: (state: boolean) => void;
	setExpanded: (expanded: boolean) => void;
	setPrimaryNavItemIndex: React.Dispatch<number>;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const HeaderUserTypeMobile: React.FC<HeaderUserTypeMobileProps> = ({
	isOpen,
	menu,
	setExpanded,
	selectMenuIndex,
	setUserTypeVisible,
	userType,
	isUserTypeVisible,
	setPrimaryNavItemIndex,
}) => {
	const userTypeData = userType;
	const isTurnedOn =
		userTypeData.mainHeader ||
		userTypeData.locationDescription ||
		userTypeData.userTypeDescription;
	const isVisible = isUserTypeVisible;
	const isVisibleClass = isUserTypeVisible ? 'is-visible' : '';
	const isActive = isTurnedOn && isVisible;

	const onCloseButtonClicked = (
		event: React.KeyboardEvent | React.MouseEvent
	) => {
		event.stopPropagation();
		setUserTypeVisible(false);
	};

	const onClick = (e: MouseEvent, type: 'location' | 'type'): void => {
		let selectedMenuIndex: number;

		e.preventDefault();

		if (type === 'location') {
			selectedMenuIndex = menu.findIndex(
				({ additionalStyleClass }) =>
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					additionalStyleClass?.search('location-links') >= 0
			);
		}

		if (type === 'type') {
			selectedMenuIndex = menu.findIndex(
				({ additionalStyleClass }) =>
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					additionalStyleClass?.search('user-type-links') >= 0
			);
		}

		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		setSelectedMenuIndex(selectedMenuIndex);
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		setPrimaryNavItemIndex(selectedMenuIndex);
		setExpanded(true);
	};

	const setSelectedMenuIndex = (state: number) => {
		selectMenuIndex(state);
	};

	const onCloseButtonPressed = (e: React.KeyboardEvent<HTMLElement>): void => {
		const keys = getKeys(e.nativeEvent);

		if (keys.isEnter || keys.isSpace) {
			onCloseButtonClicked(e);
		}
	};

	return (
		isActive && (
			<div
				{...(!isOpen && { inert: 'true' })}
				className={['blk-ac-header-user-type-mobile', isVisibleClass].join(' ')}
			>
				<div className="icon-container">
					<i className="icon-bell fa fa-bell" />
				</div>
				<div className="message-container">
					<h3 className="message-title blk-ac-body-s-compact">
						{userTypeData.mainHeader}
					</h3>
					{userTypeData.locationDescription && (
						<p
							className="message-content blk-ac-body-xs-compact"
							dangerouslySetInnerHTML={{
								__html: userTypeData.locationDescription,
							}}
							onClick={(e) => onClick(e, 'location')}
						></p>
					)}
					{userTypeData.userTypeDescription && (
						<p
							className="message-content blk-ac-body-xs-compact"
							dangerouslySetInnerHTML={{
								__html: userTypeData.userTypeDescription,
							}}
							onClick={(e) => onClick(e, 'type')}
						></p>
					)}
				</div>
				<div className="action-container">
					<i
						role="button"
						aria-label="Close user type selector"
						tabIndex={0}
						className="action-close fa fa-times"
						onKeyDown={(e) => onCloseButtonPressed(e)}
						onClick={(e) => onCloseButtonClicked(e)}
					/>
				</div>
			</div>
		)
	);
};

export default HeaderUserTypeMobile;
